import styled from 'styled-components'
import { white, lightgray, red } from '../../styles/colors'
import { maxmedia } from '../../styles/media-queries'

export const Container = styled.div`
  background: ${white};
  margin-bottom: 1rem;
  border: 1px solid ${lightgray};
  padding-bottom: ${props => props.active ? '1rem' : '0'}
`

export const Title = styled.div`
  padding: 1.5rem 0;
  margin: 0 2rem;
  font-size: 22px;
  font-weight: 600;
  position: relative;
  padding-right: 3rem;
  line-height: 1.2;
  cursor: pointer;

  ${maxmedia.medium`
    margin: 0 1rem;
    padding: 1rem 0;
    font-size: 18px;
  `};

  svg {
    transition: all 0.3s;
    width: 1rem;
    height: 1rem;
    fill: ${red};
    position: absolute;
    right: 0;
    top: 50%;
    transform: ${props => props.active ? 'translateY(-50%) rotate(0)' : 'translateY(-50%) rotate(45deg)'};

    ${maxmedia.medium`
      width: 0.75rem;
      height: 0.75rem;
    `};
  }

  
`

export const Content = styled.div`
  transition: ${props => props.active ? 'opacity 0.3s' : 'none'};
  height: ${props => props.active ? 'auto' : '0'};
  padding: 0 2rem;
  opacity: ${props => props.active ? '1' : '0'};

  ${maxmedia.medium`
    padding: 0 1rem;
`};
`


// WEBPACK FOOTER //
// ./src/components/Question/styles.js